import { Router } from 'next/router'
import { useEffect, useRef } from 'react'

import { CustomSiteMapEvent } from '@/helpers/AnalyticsSegmentHelper'

export const MarketingCloudSiteMap: React.FC = () => {
  // Utilise useRef to prevent reload when value is changed
  const sfEventFired = useRef(false)

  // When route change is started, return sfEventFired.current value to default (false)
  useEffect(() => {
    const handleRouteChange = () => {
      sfEventFired.current = false
    }

    Router.events.on('routeChangeStart', handleRouteChange)

    return () => {
      Router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [])

  useEffect(() => {
    const handleSegmentEventFired = (ev: Event) => {
      if (!sfEventFired.current) {
        if (ev instanceof CustomSiteMapEvent) {
          const { detail } = ev

          const sfEvent = new CustomEvent('page_transition', { detail })
          const messageId: string | undefined = window.dataLayer?.[(window.dataLayer?.length || 0) - 1]?.messageId

          // Based on requirement, if last pushed event matches that of current event being observed, dispatch SFMC event right away
          if (messageId && messageId === detail.message_id) {
            window.dispatchEvent(sfEvent)
          }
          // Otherwise, only dispatch after 300ms to ensure the correct/current event data exists in dataLayer
          else {
            setTimeout(() => {
              window.dispatchEvent(sfEvent)
            }, 300)
          }

          sfEventFired.current = true
        }
      }
    }

    window.addEventListener('segment_event_fired', handleSegmentEventFired)

    return () => {
      window.removeEventListener('segment_event_fired', handleSegmentEventFired)
    }
  }, [])

  return null
}
